import { InputBase, styled } from '@mui/material';
import React, { useCallback, useState } from 'react';

// Container lays out label on the left and field on the right
const Root = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  // width: '100%',
}));

const Label = styled('div')(() => ({
  color: '#394b57',
  fontSize: 14,
  lineHeight: '20px',
  userSelect: 'none',
}));

const FieldOuter = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  height: '28px',
  borderRadius: 4,
  padding: '0 12px',
  backgroundColor: '#FFFFFF',
  border: '1px solid #D8DCDF',
  boxShadow: '0 -1px 0 0 rgba(0,0,0,0.20), 0 1px 0 0 #ffffff',
  transition: 'background .15s, border-color .15s, box-shadow .15s, color .15s',
  '[data-hover="true"] &': {
    backgroundColor: '#FFFFFF',
  },
  '[data-variant="ghost"] &': {
    backgroundColor: '#E9EBED',
  },
  '[data-variant="focus"] &': {
    boxShadow: `inset 0 0 0 1px ${theme.palette.spruce['800Base']}`,
  },
  '[data-variant="output"] &': {
    backgroundColor: '#f1f2f2',
  },
  '&[data-disabled="true"]': {
    background: '#DDE2E4',
    border: '1px solid #BAC5C9',
  },
}));

const ValueText = styled('div', { shouldForwardProp: (prop) => prop !== 'align' })(({ align }) => ({
  color: '#394b57',
  fontSize: 14,
  width: '100%',
  textAlign: align || 'left',
}));

const StyledInput = styled(InputBase, { shouldForwardProp: (prop) => prop !== 'align' })(
  ({ align }) => ({
    width: '100%',
    '& input': {
      padding: 0,
      textAlign: align || 'left',
      fontSize: 14,
      color: '#394b57',
    },
  }),
);

export const InputStd = ({
  label = '',
  value = '',
  onChange,
  variant = 'input',
  disabled = false,
  width = '100%',
  inputProps,
  hideLabel = false,
  align = 'right',
  ...props
}) => {
  const [hover, setHover] = useState(false);
  const handleEnter = useCallback(() => setHover(true), []);
  const handleLeave = useCallback(() => setHover(false), []);

  const renderField = () => {
    if (variant === 'ghost') {
      // Hide text but keep field layout
      return <ValueText align={align}></ValueText>;
    }
    if (variant === 'output' || disabled || typeof onChange !== 'function') {
      return <ValueText align={align}>{value}</ValueText>;
    }
    return (
      <StyledInput
        align={align}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        disabled={disabled}
        inputProps={{ 'aria-label': label, ...inputProps }}
      />
    );
  };

  return (
    <Root
      data-variant={variant}
      data-hover={hover ? 'true' : 'false'}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      {...props}
    >
      {!hideLabel && <Label>{label}</Label>}
      <FieldOuter data-disabled={disabled ? 'true' : 'false'} sx={{ width }}>
        {renderField()}
      </FieldOuter>
    </Root>
  );
};

export default InputStd;
